module.exports = __webpack_public_path__ + "img/file-plus-02.54f514fd.svg";